import { render } from "./RelatorioBatidaMensal.vue?vue&type=template&id=2d684c15&scoped=true"
import script from "./RelatorioBatidaMensal.vue?vue&type=script&lang=js"
export * from "./RelatorioBatidaMensal.vue?vue&type=script&lang=js"

import "./RelatorioBatidaMensal.vue?vue&type=style&index=0&id=2d684c15&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d684c15"]])

export default __exports__